import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { getPrimaryAgreementFields } from '../form-interfaces/agreements-primary-interface';
import { getOptionalFields } from '../form-interfaces/agreements-optional-interface';
import { getCoAppAgreementFields } from '../form-interfaces/agreements-coapp-interface';
import { callLoader, getFormlyChangedValues, hasRequiredContactChanges } from '../../helper-functions/docusign-utils';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocusignService } from '@lmc-app/core/services/docusign.service';
import dayjs from 'dayjs';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Loading } from '@lmc-app/applications/loading';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-agreements-validation',
  templateUrl: './agreements-validation.component.html',
  styleUrls: ['./agreements-validation.component.scss']
})

export class AgreementsValidationComponent implements OnInit {

  formlyForm = new FormGroup({});   // Initialize the FormGroup correctly
  formlyFields: FormlyFieldConfig[] = [];   // separate variable for the field configuration array
  dataModel = {};   // Holds form data
  options: FormlyFormOptions = {};

  private readonly _dialog = inject(MatDialog);
  private maxCalendarDate = new Date(new Date().getFullYear() - 1, 11, 31);
  private readonly _bottomSheet = inject(MatBottomSheet);

  constructor(
      private _docusignService: DocusignService,   
      private dialogRef: MatDialogRef<AgreementsValidationComponent>,
      @Inject(MAT_DIALOG_DATA) public data,

    ){
      this.dataModel = data?.model;
      // console.log(data,"==================")
    }

  ngOnInit(): void {    
    this.mapFormWithCard(this.data?.formName);
  }

  saveChanges() {
    const ref = callLoader(this._bottomSheet, 'Saving...'); 
    const updatedData = getFormlyChangedValues(this.formlyForm, this.dataModel);
    
    const DealNameValue = (hasRequiredContactChanges(updatedData)) 
          ?  { [this.dataModel['DealName'].zoho_field_name]: [this.dataModel['FirstName'].value,this.dataModel['MiddleName'].value,this.dataModel['LastName'].value].filter(Boolean).join(' ') }
          : null;

    const zohoUpdateData = Object.assign(
      {}, 
      ...Object.values(updatedData), 
      (!!DealNameValue ? DealNameValue : ''),
      { Override_Type: `${this.data?.userInfo?.full_name} (${dayjs().format('YYYY-MM-DD HH:mm:ss')})`}
    );
    
    this._docusignService.saveDocusignZohoChanges(this.data?.applicationId, zohoUpdateData, this.dataModel?.['ContactId'].value).pipe(
      finalize(() => {
        ref.dismiss(); 
        this.dialogRef.close(true);
      })
    ).subscribe({
      next: (response)=>{
        if(response)
          this.dialogRef.close(true);
      }
    })
  }

  cancel(){
    this.dialogRef.close(false);
  }

  mapFormWithCard(formName:string){
    switch (formName) {
      case "primary":      
        this.formlyFields = getPrimaryAgreementFields(this.data?.formOptions,this.maxCalendarDate,false, 'col-sm-6 col-lg-4');
        break;
      case "co-applicant": 
        this.formlyFields = getCoAppAgreementFields(this.data?.formOptions,this.maxCalendarDate,false, 'col-sm-6 col-lg-4');
        break;
      default: 
        this.formlyFields = getOptionalFields(false, 'col-sm-6 col-lg-4');
        break;
    }
  }
}
